export default "__VITE_ASSET__3nji9zge__"